module.exports = __webpack_public_path__ + "img/H01121-112.09910105.jpg";